function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Manage-Credit-Cards",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "00:-Table-of-Contents",
  transform: "translate(-725.000000, -396.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(698.000000, 336.000000)"
}, React.createElement("g", {
  id: "icon-credit-card",
  transform: "translate(38.124344, 67.000000) rotate(-360.000000) translate(-38.124344, -67.000000) translate(28.624344, 60.000000)"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, 0.616255)",
  stroke: "#A1A5B3",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.000000, 0.383745)"
}, React.createElement("rect", {
  id: "Rectangle-Copy-21",
  x: 0,
  y: 0,
  width: 19,
  height: 12,
  rx: 1
}))), React.createElement("rect", {
  id: "Rectangle-Copy-22",
  fill: "#A1A5B3",
  x: 1,
  y: 4,
  width: 18,
  height: 3
}), React.createElement("rect", {
  id: "Rectangle-Copy-23",
  fill: "#A1A5B3",
  x: 2.65530315,
  y: 8.52268696,
  width: 9,
  height: 2
}), React.createElement("rect", {
  id: "Rectangle-Copy-24",
  fill: "#A1A5B3",
  x: 13.8793086,
  y: 8.52268696,
  width: 2.65957551,
  height: 2
})))));

function SvgTableHeaderIconCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["svgRef", "title", "titleId"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? React.createElement("title", {
    id: titleId
  }, "icon-credit-card") : title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTableHeaderIconCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table-header-icon-credit-card.75a9873d.svg";
export { ForwardRef as ReactComponent };